"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const AbstractGroupedDropdown_1 = tslib_1.__importDefault(require("./AbstractGroupedDropdown"));
class GroupedFormListBoxModel {
    formatItem(item) {
        return item;
    }
    isEqual(a, b) {
        return a === b;
    }
    getTextForNoOptionSelected() {
        return "Vælg mulighed";
    }
    formatGroup(form) {
        return form;
    }
}
/**
 * @deprecated Use {@link WCAGStringGroupedDropdown} instead.
 */
class StringGroupedDropdown extends AbstractGroupedDropdown_1.default {
    constructor() {
        super(new GroupedFormListBoxModel());
    }
}
exports.default = StringGroupedDropdown;
//# sourceMappingURL=StringGroupedDropdown.js.map